import { Component } from '@angular/core';
import { HeroComponent } from '../../components/sections/hero/hero.component';
import { ProblemComponent } from '../../components/sections/problem/problem.component';
import { FormatsComponent } from '../../components/sections/formats/formats.component';
import { QuizPrepComponent } from '../../components/sections/quiz-prep/quiz-prep.component';
import { StepsComponent } from '../../components/sections/steps/steps.component';
import { DjControlComponent } from '../../components/sections/dj-control/dj-control.component';
import { NoAppComponent } from '../../components/sections/no-app/no-app.component';
import { TrustComponent } from '../../components/sections/trust/trust.component';
import { TestimonialsComponent } from '../../components/sections/testimonials/testimonials.component';
import { FaqComponent } from '../../components/sections/faq/faq.component';
import { ContactSectionComponent } from '../../components/sections/contact-section/contact-section.component';
import { CtaComponent } from '../../components/sections/cta/cta.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeroComponent,
    ProblemComponent,
    FormatsComponent,
    QuizPrepComponent,
    StepsComponent,
    DjControlComponent,
    NoAppComponent,
    TrustComponent,
    TestimonialsComponent,
    FaqComponent,
    ContactSectionComponent,
    CtaComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {}
